<template>
  <div class="product-item" v-if="room">
    <a @click.prevent="onGotoRoomPromotion(room)" class="image-fit pointer">
      <img
        v-if="room.ImageIds && room.ImageIds.length > 0"
        :src="getImageUri(room.ImageIds[0])"
        alt
      />
      <img
        v-if="room.ImageIds && room.ImageIds.length === 0"
        src="../assets/images/product1.jpg"
        alt
      />
    </a>
    <div class="info-text">
      <h3 class="font-balo">
        <a @click.prevent="onGotoRoomPromotion(room)" class="pointer">
          {{ getTranslate(room.Name) }}
        </a>
        <div class="location font-bai" v-if="room.camping">
          <i>{{ room.camping.name }}</i>
        </div>
      </h3>
      <div class="des font-bai" v-html="getTranslate(room.Description)"></div>
      <ul
        class="pro-services list-inline font-bai font-bold"
        v-if="services && services.length"
      >
        <li
          class="item-inline"
          v-for="(service, index) in services"
          :key="index"
        >
          <img v-if="service.icon" :src="service.icon" alt />
          <img v-if="!service.icon" src="../assets/images/picscine.png" alt />
          {{ service.name }}
        </li>
      </ul>
    </div>
    <div class="info-price">
      <div class="time text-center">
        <b>
          <i>{{ getRoomBookTime() }}</i>
        </b>
      </div>
      <div class="price text-center">
        {{ $t("app.à partir de") }}
        <b>{{ getPrice() }} {{ currency.symbol }}</b>
      </div>
      <div class="text-center">
        <a
          @click.prevent="onGotoRoomPromotion(room)"
          class="btn font-bold pointer"
          >{{ $t("app.en savoir plus") }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { CDN_MEWS_MEDIA } from "@/api/config";
import { mapState, mapMutations, mapActions } from "vuex";
import { get, first, filter, find } from "lodash";
import moment from "moment";
import {
  numberOfNightsBetweenDates,
  formatBookDate
} from "@/helper/calculateDays";
import { ADULT_COUNT_DEFAULT } from "@/api/config";

export default {
  name: "RoomGridItem",
  props: ["room", "filter", "promotion"],
  data() {
    return {
      services: []
    };
  },
  computed: {
    ...mapState({
      references: state => get(state, "hotels.allReferences", []),
      lang: state => get(state, "app.lang", "fr"),
      currency: state => get(state, "app.currency")
    })
  },
  mounted() {
    this.services = filter(
      get(this.room, "camping.services", []),
      item => item.inclus
    );
  },
  methods: {
    ...mapActions("hotels", ["getRoom"]),
    ...mapMutations("hotels", ["setFilter"]),
    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    getRoomBookTime() {
      const dateFrom = moment(this.promotion.start_date, "DD-MM-YYYY").format(
        "ddd DD"
      );
      const dateTo = moment(this.promotion.end_date, "DD-MM-YYYY").format(
        "ddd DD"
      );
      const totalDate = numberOfNightsBetweenDates(
        moment(this.promotion.start_date, "DD-MM-YYYY"),
        moment(this.promotion.end_date, "DD-MM-YYYY")
      );
      if (totalDate > 1) {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuits")})`;
      } else {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuit")})`;
      }
    },
    getPrice() {
      const room = this.room;
      const RoomCategoryAvailabilities = get(
        room,
        "roomCategoryAvailabilities.RoomCategoryAvailabilities"
      );
      if (RoomCategoryAvailabilities) {
        const roomOccupancyAvailabilities = first(
          find(
            RoomCategoryAvailabilities,
            item => item.RoomCategoryId === room.Id
          ).RoomOccupancyAvailabilities
        );
        const roomPrice = get(
          roomOccupancyAvailabilities,
          `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
        );
        return roomPrice;
      }
    },
    onGotoRoomPromotion(room) {
      let dataReferences = {
        camping: get(room, "camping.id"),
        dateFrom: formatBookDate(
          moment(this.promotion.start_date, "DD-MM-YYYY")
        ),
        dateTo: formatBookDate(moment(this.promotion.end_date, "DD-MM-YYYY")),
        type: get(room, "type"),
        categorie: get(room, "category"),
        adult: ADULT_COUNT_DEFAULT,
        child: 0,
        child1: 0,
        voucher: this.promotion.code
      };
      this.setFilter(dataReferences);
      const roomId = room.Id;
      const roomCategory = find(this.references, item => item.id === roomId);
      if (roomCategory) {
        this.getRoom(roomCategory)
          .then(() => {
            this.$router.push(`/room/${roomId}`);
          })
          .catch(() => this.$router.push("/"));
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>
